export default function HeroVideo(handle, {
    activeClass,
    container
}) {

    const videoContainer = document.querySelector(container);
    const video = videoContainer.querySelector('video');
    const buttons = document.querySelectorAll('.hero-btn-link');
    let currentIndex = 0;
    const interval = 7;
    let intervalId;

    function selectButton() {
        buttons.forEach(button => button.classList.remove('highlighted'));
        buttons[currentIndex].classList.add('highlighted');
        currentIndex = (currentIndex + 1) % buttons.length;
    }

    function startHighlighting() {
        // Clear any existing interval to avoid multiple intervals running
        if (intervalId) {
            clearInterval(intervalId);
        }
        // Reset the current index
        currentIndex = 0;
        // Highlight the first button immediately
        selectButton();
        // Set an interval to change the highlighted button every 7 seconds
        intervalId = setInterval(() => {
            if (video.paused || video.ended) {
                clearInterval(intervalId);
            } else {
                selectButton();
            }
        }, interval * 1000);
    }

    function handleHover(event) {
        // Get timestamp based on button (use data attribute or array index)
        let targetTimestamp;
        if (buttons[currentIndex].hasAttribute('data-timestamp')) {
            targetTimestamp = parseFloat(event.target.dataset.timestamp);
            currentIndex = parseFloat(event.target.dataset.index);
            selectButton()
            //buttons.forEach(button => button.classList.remove('highlighted'));
            //buttons[currentIndex].classList.add('highlighted');
            //currentIndex = (currentIndex + 1) % buttons.length;
        } else {
            targetTimestamp = 0;
        }

        // Update video playback time and highlighting interval
        video.currentTime = targetTimestamp;
        updateHighlightInterval(targetTimestamp); // New function
    }

    buttons.forEach(button => button.addEventListener('mouseenter', handleHover));

    function updateHighlightInterval(newTime) {
        // Calculate remaining time in the current interval
        const remainingTime = (interval - (video.currentTime % interval)) * 1000;

        // Clear the existing interval
        clearInterval(intervalId);

        // Set a new interval starting from the remaining time
        intervalId = setInterval(() => {
            if (video.paused || video.ended) {
                clearInterval(intervalId);
            } else {
                selectButton();
            }
        }, remainingTime);
    }

    video.addEventListener('play', startHighlighting);

    video.addEventListener('ended', () => {
        // Restart highlighting process when the video loops
        startHighlighting();
    });

    // If the video is looping (autoplay and loop), we need to handle the loop by detecting the time reset
    video.addEventListener('timeupdate', () => {
        if (video.currentTime < 0.125) {
            startHighlighting();
        }
    });





}